/**
 * Turning an API refusal into a sentence, for the inquiry screens.
 *
 * WEB TIER A · WT5 — RELOCATED VERBATIM. `createErrorText` lived at the foot of
 * `NewInquiryPanel.tsx` and `peekErrorText` at the foot of `PeekPanel.tsx`;
 * both files died with the slide-over kill, and the sentences survive them
 * because they never described a panel — they describe the API's refusals, and
 * the full pages that replaced the panels are refused in exactly the same ways.
 *
 * `peekErrorText` KEEPS ITS NAME, deliberately: it is the house shape
 * `features/quotes/errors.ts` cites as its model ("translate the two or three
 * codes a screen can act on, and otherwise return `error.message` verbatim"),
 * and renaming it would orphan that provenance for no behavioural gain. The
 * "peek" in the name is now historical — the record page and the follow-up
 * page are its callers.
 */

import { ApiRequestError } from '../../lib/api';

/** A refusal on the create surfaces (inquiry create, prospect search/create). */
export function createErrorText(error: unknown): string {
  if (error instanceof ApiRequestError) {
    if (error.status === 403) return 'You do not have permission to do that here.';
    if (error.code === 'COUNTRY_SCOPE_VIOLATION') return 'That record is in another country.';
    return error.message;
  }
  return 'The server could not be reached.';
}

/** A refusal on an inquiry read — the record page and the follow-up page. */
export function peekErrorText(error: unknown): string {
  if (error instanceof ApiRequestError) {
    if (error.code === 'COUNTRY_SCOPE_VIOLATION') {
      return 'That inquiry belongs to another country.';
    }
    if (error.status === 404) return 'That inquiry does not exist.';
    if (error.status === 403) return 'You do not have permission to view this inquiry.';
    return error.message;
  }
  return 'The inquiry could not be loaded.';
}
